module.exports = __webpack_public_path__ + "img/algo.75c995d0.svg";